/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import { header700, UiTextMedium } from '../../shared/typography';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 50px;
  /* margin top for nth div child */
  & > span:nth-child(3) {
    margin-bottom: 40px;
  }
`;

const Header400 = styled.span`
  margin-bottom: 20px;
  ${header700}
`;

const ErrorMessage = styled.pre`
  color: red;
  margin: 5px;
`;

interface ErrorProps {
  error: Error,
  resetErrorBoundary: () => void,
}

const SErrorBoundaryPage = ({ error, resetErrorBoundary }: ErrorProps) => {
  const hei = '2';

  return (
    <Container>
      <Header400>Oh no!🥲 </Header400>
      <Header400>Something went wrong</Header400>

      <UiTextMedium>Please refresh the browser to start using Shepherd again</UiTextMedium>
      <ErrorMessage>Error:</ErrorMessage>
      <ErrorMessage>{error.message}</ErrorMessage>
      {/* <button onClick={resetErrorBoundary} type="button">Try again</button> */}
    </Container>
  );
};

export default SErrorBoundaryPage;
